import React from "react";

import moment from "moment";

import { withRouter } from "react-router-dom";

import LocationFormat from "../../../../utils/LocationFormat";
import BaseTable from "../BaseTable";
import General from "../../../../utils/General";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import FetchHelper from "../../../../utils/FetchHelper";

import Backend from "../../../../utils/Backend";
import Notify from "../../../../utils/Notify";

class ManageCustomersTable extends React.Component {
  constructor(props) {
    super(props);

    // this.state = {};
    this.state = {
      exporting: false,
      selectedUnverifiedUsers: {},
      verificationEmailsSending: false,
    };
    this.table = React.createRef();
  }

  componentWillReceiveProps(nextProps) {
    this.setState(nextProps);
  }


  async _exportData() {
  try {
    this.setState({ exporting: true });

    const tableState = this.table?.current?.state;

    if (!tableState) {
      alert("Table not ready.");
      this.setState({ exporting: false });
      return;
    }

    // 1) Build URL like BaseTable
    let exportState = {
      ...tableState,
      page: 0,
      pageSize: 99999,
      sorted: [{ id: "created_at", desc: true }],
    };

    let url = this.table.current._getUrl(window.Api.Customers, exportState);
    console.log("ManageCustomersTable export URL:", url);

    // 2) Authenticated request with FetchHelper
    const response = await FetchHelper.get(url, false);
    console.log("Export response:", response);

    const customers = response?.results || [];

    if (!customers.length) {
      alert("No customer data found.");
      this.setState({ exporting: false });
      return;
    }

    // // 3) Format rows
    // const exportData = customers.map(customer => ({
    //   Name:
    //     `${customer?.user?.first_name ?? ""} ${customer?.user?.last_name ?? ""}`.trim(),
    //   Email: customer?.user?.email || "-",
    //   Phone: customer?.user?.phone_number || "-",
    //   Orders: customer?.order_count ?? 0,
    //   LastOrder:
    //     customer?.last_order_at
    //       ? moment(customer?.last_order_at).format("DD MMM YYYY - hh:mm A")
    //       : "-",
    // }));



//     const exportData = customers.map(customer => ({
//   Name:
//     `${customer?.user?.first_name ?? ""} ${customer?.user?.last_name ?? ""}`.trim(),
//   Email: customer?.user?.email || "-",
//   Phone: customer?.user?.phone_number || "-",
//   RegistrationDate:
//     customer?.user?.created_at || customer?.created_at
//       ? moment(customer?.user?.created_at || customer?.created_at).format("DD MMM YYYY - hh:mm A")
//       : "-",
//   Orders: customer?.order_count ?? 0,
//   LastOrder:
//     customer?.last_order_at
//       ? moment(customer?.last_order_at).format("DD MMM YYYY - hh:mm A")
//       : "-",
// }));


const exportData = customers.map((customer) => {
  const address =
    customer?.address ||
    customer?.user?.address ||
    customer?.default_address ||
    customer?.data?.customer_address ||
    customer?.addresses?.[0];

  const county =
    customer?.county ||
    customer?.user?.county ||
    address?.county ||
    address?.state ||
    address?.city ||
    address?.administrative_area_level_2 ||
    address?.formatted_address ||
    "-";

  const hasPhone =
    customer?.user?.phone_number ||
    customer?.phone_number ||
    customer?.mobile;

  const hasAddress =
    customer?.address ||
    customer?.user?.address ||
    customer?.data?.customer_address ||
    customer?.default_address ||
    customer?.addresses?.length > 0;

  const hasOrder = Number(customer?.order_count || 0) > 0;

  const continued = hasPhone || hasAddress || hasOrder;

  const isVerified =
    customer?.user?.email_verified === true ||
    customer?.user?.email_verified === "true";

  return {
    Name: `${customer?.user?.first_name ?? ""} ${
      customer?.user?.last_name ?? ""
    }`.trim(),
    Email: customer?.user?.email || "-",
    EmailVerified: isVerified ? "Verified" : "Not Verified",
    Phone: hasPhone || "-",
    AppContinued: continued ? "Continued" : "Did Not Continue",
    County: county,
    RegistrationDate:
      customer?.user?.created_at || customer?.created_at
        ? moment(customer?.user?.created_at || customer?.created_at).format(
            "DD MMM YYYY - hh:mm A"
          )
        : "-",
    Orders: customer?.order_count ?? 0,
    LastOrder: customer?.last_order_at
      ? moment(customer?.last_order_at).format("DD MMM YYYY - hh:mm A")
      : "-",
  };
});



    // 4) Build XLSX
    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Customers");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });

    // 5) Download file
    saveAs(blob, `customers_export_${Date.now()}.xlsx`);

  } catch (err) {
    console.error("Export failed", err);
    alert("Failed to export data.");
  } finally {
    // always stop loading, even if error occurs
    this.setState({ exporting: false });
  }
}







_isEmailVerified(customer) {
  return (
    customer?.user?.email_verified === true ||
    customer?.user?.email_verified === "true" ||
    Boolean(customer?.user?.email_verified_at)
  );
}

_toggleUnverifiedUser(customer) {
  const userId = customer?.user?.id;
  const email = customer?.user?.email;

  if (this._isEmailVerified(customer) || !userId || !email) {
    return;
  }

  this.setState((state) => {
    const selectedUnverifiedUsers = {
      ...state.selectedUnverifiedUsers,
    };

    if (selectedUnverifiedUsers[userId]) {
      delete selectedUnverifiedUsers[userId];
    } else {
      selectedUnverifiedUsers[userId] = {
        user_id: userId,
        email,
      };
    }

    return { selectedUnverifiedUsers };
  });
}

// async _sendVerificationEmails() {
//   const selectedUsers = Object.values(
//     this.state.selectedUnverifiedUsers
//   );

//   if (!selectedUsers.length) {
//     Notify.error("Please select at least one unverified user.");
//     return;
//   }

//   this.setState({ verificationEmailsSending: true });

//   try {
//     const results = await Promise.allSettled(
//       selectedUsers.map((user) =>
//         Backend.sendVerificationEmail(user)
//       )
//     );

//     const successfulUserIds = [];

//     results.forEach((result, index) => {
//       if (result.status === "fulfilled") {
//         successfulUserIds.push(
//           String(selectedUsers[index].user_id)
//         );
//       }
//     });

//     const failedCount =
//       selectedUsers.length - successfulUserIds.length;

//     this.setState((state) => {
//       const selectedUnverifiedUsers = {
//         ...state.selectedUnverifiedUsers,
//       };

//       successfulUserIds.forEach((userId) => {
//         delete selectedUnverifiedUsers[userId];
//       });

//       return { selectedUnverifiedUsers };
//     });

//     if (successfulUserIds.length) {
//       Notify.success(
//         `Verification emails sent to ${successfulUserIds.length} user(s).`
//       );
//     }

//     if (failedCount) {
//       Notify.error(
//         `Failed to send ${failedCount} verification email(s).`
//       );
//     }
//   } catch (error) {
//     Notify.error(
//       error.message || "Failed to send verification emails."
//     );
//   } finally {
//     this.setState({ verificationEmailsSending: false });
//   }
// }











async _sendVerificationEmails() {
  const selectedUsers = Object.values(
    this.state.selectedUnverifiedUsers
  );

  if (!selectedUsers.length) {
    Notify.error("Please select at least one unverified user.");
    return;
  }

  const userIds = selectedUsers.map(
    (user) => user.user_id
  );

  this.setState({
    verificationEmailsSending: true,
  });

  try {
    const response = await Backend.sendVerificationEmails(
      userIds
    );

    this.setState({
      selectedUnverifiedUsers: {},
    });

    Notify.success(
      response?.message ||
        `${userIds.length} verification email(s) queued.`
    );
  } catch (error) {
    console.error(
      "Send verification emails failed:",
      error
    );

    Notify.error(
      error?.message ||
        "Failed to queue verification emails."
    );
  } finally {
    this.setState({
      verificationEmailsSending: false,
    });
  }
}








  // _getColumns() {
  //   return [
  //     {
  //       Header: () => <strong className="header__clr">USER</strong>,
  //       id: "user__first_name",
  //       Cell: (rowInfo) => {
  //         let customer = rowInfo.original;

  //         let nameDetails = `${General.toTitleCase(
  //           customer?.user?.first_name
  //         )} ${General.toTitleCase(customer?.user?.last_name)}`;

  //         if (!nameDetails) {
  //           return "-";
  //         }

  //         return (
  //           <>
  //             <span>{nameDetails}</span>
  //             <br />
  //             <a
  //               href="javascript:;"
  //               className="font-size-sm text-dark-50 text-hover-primary"
  //             >
  //               {customer?.user?.email ?? "-"}
  //             </a>
  //           </>
  //         );
  //       },
  //     },
  //     {
  //       Header: () => <strong className="header__clr">PHONE NUMBER</strong>,
  //       id: "phone_number",
  //       sortable: false,
  //       Cell: (rowInfo) => {
  //         let customer = rowInfo.original;

  //         let phoneNumber = customer?.user?.phone_number;

  //         if (!phoneNumber) {
  //           return "-";
  //         }

  //         return <span>{phoneNumber}</span>;
  //       },
  //     },
  //     // ✅ NEW: COUNTY
  //     {
  //       Header: () => <strong className="header__clr">COUNTY</strong>,
  //       id: "county",
  //       sortable: false,
  //       Cell: (rowInfo) => {
  //         const customer = rowInfo.original;

  //         // Try common shapes: user.county, user.address.county, customer.address.county etc.
  //         const county =
  //           customer?.user?.county ||
  //           customer?.user?.address?.county ||
  //           customer?.address?.county ||
  //           customer?.data?.customer_address?.county ||
  //           customer?.data?.customer_address?.state ||   // sometimes used
  //           customer?.county;

  //         return county ? <span>{county}</span> : "-";
  //       },
  //     },
  //     {
  //       Header: () => <strong className="header__clr">REGISTRATION DATE & TIME</strong>,
  //       id: "created_at",
  //       Cell: (rowInfo) => {
  //         const customer = rowInfo.original;

  //         const registrationDate =
  //           customer?.user?.created_at ||
  //           customer?.created_at ||
  //           customer?.date_joined ||
  //           customer?.user?.date_joined;

  //         if (!registrationDate) {
  //           return "-";
  //         }

  //         return (
  //           <span>
  //             {moment(registrationDate).format("DD MMM YYYY - hh:mm A")}
  //           </span>
  //         );
  //       },
  //     },
  //     {
  //       Header: () => <strong className="header__clr">ORDERS</strong>,
  //       id: "order_count",
  //       Cell: (rowInfo) => {
  //         let customer = rowInfo.original;

  //         let orderCount = customer?.order_count;

  //         return (
  //           <>
  //             <span>{orderCount}</span>
  //           </>
  //         );
  //       },
  //     },
  //     {
  //       Header: () => <strong className="header__clr">LAST ORDER</strong>,
  //       id: "last_order_at",
  //       Cell: (rowInfo) => {
  //         let customer = rowInfo.original;

  //         let lastOrder = `${moment(customer?.last_order_at).format(
  //           "DD MMM YYYY - hh:mm A"
  //         )}`;

  //         return (
  //           <>
  //             <span>{customer?.last_order_at !== null ? lastOrder : "-"}</span>
  //           </>
  //         );
  //       },
  //     },

  //     {
  //       Header: () => <strong className="header__clr">ACTIONS</strong>,
  //       id: "id",
  //       sortable: false,
  //       Cell: (rowInfo) => {
  //         let customer = rowInfo.original;

  //         let customerId = customer.user.id;

  //         return (
  //           <>
  //             <span style={{ width: 211 }}>
  //               {" "}
  //               <a
  //                 href={`/manage-customers/${customerId}`}
  //                 className="btn btn-icon btn-sm btn-pill btn-outline-primary mr-2"
  //                 data-toggle="popover"
  //                 data-content="Manage User"
  //               >
  //                 {" "}
  //                 <span className="svg-icon svg-icon-md">
  //                   {" "}
  //                   <svg
  //                     xmlns="http://www.w3.org/2000/svg"
  //                     xmlnsXlink="http://www.w3.org/1999/xlink"
  //                     width="24px"
  //                     height="24px"
  //                     viewBox="0 0 24 24"
  //                     version="1.1"
  //                   >
  //                     {" "}
  //                     <g
  //                       stroke="none"
  //                       strokeWidth={1}
  //                       fill="none"
  //                       fillRule="evenodd"
  //                     >
  //                       {" "}
  //                       <rect x={0} y={0} width={24} height={24} />{" "}
  //                       <path
  //                         d="M8,17.9148182 L8,5.96685884 C8,5.56391781 8.16211443,5.17792052 8.44982609,4.89581508 L10.965708,2.42895648 C11.5426798,1.86322723 12.4640974,1.85620921 13.0496196,2.41308426 L15.5337377,4.77566479 C15.8314604,5.0588212 16,5.45170806 16,5.86258077 L16,17.9148182 C16,18.7432453 15.3284271,19.4148182 14.5,19.4148182 L9.5,19.4148182 C8.67157288,19.4148182 8,18.7432453 8,17.9148182 Z"
  //                         fill="#FF5E8A"
  //                         fillRule="nonzero"
  //                         transform="translate(12.000000, 10.707409) rotate(-135.000000) translate(-12.000000, -10.707409) "
  //                       />{" "}
  //                       <rect
  //                         fill="#FF5E8A"
  //                         opacity="0.3"
  //                         x={5}
  //                         y={20}
  //                         width={15}
  //                         height={2}
  //                         rx={1}
  //                       />{" "}
  //                     </g>{" "}
  //                   </svg>
  //                 </span>{" "}
  //               </a>{" "}
  //             </span>
  //           </>
  //         );
  //       },
  //     },
  //   ];
  // }


  _getColumns() {
  return [
    {
  Header: () => (
    <strong className="header__clr">SELECT</strong>
  ),
  id: "select_unverified_email",
  sortable: false,
  width: 80,
  Cell: (rowInfo) => {
    const customer = rowInfo.original;
    const userId = customer?.user?.id;
    const email = customer?.user?.email;
    const isVerified = this._isEmailVerified(customer);

    if (isVerified || !userId || !email) {
      return "-";
    }

    return (
      <input
        type="checkbox"
        checked={Boolean(
          this.state.selectedUnverifiedUsers[userId]
        )}
        disabled={this.state.verificationEmailsSending}
        onChange={() =>
          this._toggleUnverifiedUser(customer)
        }
        aria-label={`Select ${email}`}
      />
    );
  },
},
    {
      Header: () => <strong className="header__clr">USER</strong>,
      id: "user__first_name",
      Cell: (rowInfo) => {
        const customer = rowInfo.original;

        const firstName = customer?.user?.first_name || "";
        const lastName = customer?.user?.last_name || "";
        const fullName = `${General.toTitleCase(firstName)} ${General.toTitleCase(lastName)}`.trim();

        return (
          <>
            <span>{fullName || "-"}</span>
            <br />
            <a
              href="javascript:;"
              className="font-size-sm text-dark-50 text-hover-primary"
            >
              {customer?.user?.email || "-"}
            </a>
          </>
        );
      },
    },

    {
      Header: () => <strong className="header__clr">EMAIL VERIFIED</strong>,
      id: "email_verified",
      sortable: false,
      Cell: (rowInfo) => {
        const customer = rowInfo.original;

        const isVerified =
          customer?.user?.email_verified === true ||
          customer?.user?.email_verified === "true";

        return (
          <span
            className={`label label-lg label-inline ${
              isVerified ? "label-light-success" : "label-light-danger"
            }`}
          >
            {isVerified ? "Verified" : "Not Verified"}
          </span>
        );
      },
    },

    {
      Header: () => <strong className="header__clr">PHONE NUMBER</strong>,
      id: "phone_number",
      sortable: false,
      Cell: (rowInfo) => {
        const customer = rowInfo.original;

        const phoneNumber =
          customer?.user?.phone_number ||
          customer?.phone_number ||
          customer?.mobile ||
          "-";

        return <span>{phoneNumber}</span>;
      },
    },

    {
      Header: () => <strong className="header__clr">APP CONTINUED</strong>,
      id: "app_continued",
      sortable: false,
      Cell: (rowInfo) => {
        const customer = rowInfo.original;

        const hasPhone =
          customer?.user?.phone_number ||
          customer?.phone_number ||
          customer?.mobile;

        const hasAddress =
          customer?.address ||
          customer?.user?.address ||
          customer?.data?.customer_address ||
          customer?.default_address ||
          customer?.addresses?.length > 0;

        const hasOrder =
          Number(customer?.order_count || 0) > 0;

        const continued = hasPhone || hasAddress || hasOrder;

        return (
          <span
            className={`label label-lg label-inline ${
              continued ? "label-light-success" : "label-light-warning"
            }`}
          >
            {continued ? "Continued" : "Did Not Continue"}
          </span>
        );
      },
    },

    {
      Header: () => <strong className="header__clr">COUNTY</strong>,
      id: "county",
      sortable: false,
      Cell: (rowInfo) => {
        const customer = rowInfo.original;

        const address =
          customer?.address ||
          customer?.user?.address ||
          customer?.default_address ||
          customer?.data?.customer_address ||
          customer?.addresses?.[0];

        const county =
          customer?.county ||
          customer?.user?.county ||
          address?.county ||
          address?.state ||
          address?.city ||
          address?.administrative_area_level_2 ||
          address?.formatted_address;

        return <span>{county || "-"}</span>;
      },
    },

    {
      Header: () => <strong className="header__clr">REGISTERED</strong>,
      id: "created_at",
      Cell: (rowInfo) => {
        const customer = rowInfo.original;

        const registrationDate =
          customer?.user?.created_at ||
          customer?.created_at ||
          customer?.user?.date_joined ||
          customer?.date_joined;

        if (!registrationDate) {
          return "-";
        }

        return (
          <span>
            {moment(registrationDate).format("DD MMM YYYY - hh:mm A")}
          </span>
        );
      },
    },

    {
      Header: () => <strong className="header__clr">ORDERS</strong>,
      id: "order_count",
      Cell: (rowInfo) => {
        const customer = rowInfo.original;

        return <span>{customer?.order_count ?? 0}</span>;
      },
    },

    {
      Header: () => <strong className="header__clr">LAST ORDER</strong>,
      id: "last_order_at",
      Cell: (rowInfo) => {
        const customer = rowInfo.original;

        if (!customer?.last_order_at) {
          return "-";
        }

        return (
          <span>
            {moment(customer.last_order_at).format("DD MMM YYYY - hh:mm A")}
          </span>
        );
      },
    },

    {
      Header: () => <strong className="header__clr">ACTIONS</strong>,
      id: "id",
      sortable: false,
      Cell: (rowInfo) => {
        const customer = rowInfo.original;

        const customerId = customer?.user?.id;

        if (!customerId) {
          return "-";
        }

        return (
          <>
            <span style={{ width: 211 }}>
              <a
                href={`/manage-customers/${customerId}`}
                className="btn btn-icon btn-sm btn-pill btn-outline-primary mr-2"
                data-toggle="popover"
                data-content="Manage User"
              >
                <span className="svg-icon svg-icon-md">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    width="24px"
                    height="24px"
                    viewBox="0 0 24 24"
                    version="1.1"
                  >
                    <g
                      stroke="none"
                      strokeWidth={1}
                      fill="none"
                      fillRule="evenodd"
                    >
                      <rect x={0} y={0} width={24} height={24} />
                      <path
                        d="M8,17.9148182 L8,5.96685884 C8,5.56391781 8.16211443,5.17792052 8.44982609,4.89581508 L10.965708,2.42895648 C11.5426798,1.86322723 12.4640974,1.85620921 13.0496196,2.41308426 L15.5337377,4.77566479 C15.8314604,5.0588212 16,5.45170806 16,5.86258077 L16,17.9148182 C16,18.7432453 15.3284271,19.4148182 14.5,19.4148182 L9.5,19.4148182 C8.67157288,19.4148182 8,18.7432453 8,17.9148182 Z"
                        fill="#FF5E8A"
                        fillRule="nonzero"
                        transform="translate(12.000000, 10.707409) rotate(-135.000000) translate(-12.000000, -10.707409)"
                      />
                      <rect
                        fill="#FF5E8A"
                        opacity="0.3"
                        x={5}
                        y={20}
                        width={15}
                        height={2}
                        rx={1}
                      />
                    </g>
                  </svg>
                </span>
              </a>
            </span>
          </>
        );
      },
    },
  ];
}

  render() {

    const selectedUnverifiedCount = Object.keys(
  this.state.selectedUnverifiedUsers
).length;
    const { isLoading } = this.state;

    const columns = this._getColumns();

    let tableProps = {};


    return (
      <>
        {/* <div className="d-flex justify-content-end mb-4">
          <button 
            onClick={() => this._exportData()}
            className="btn btn-success btn-sm"
          >
            Export Customers (XLSX)
          </button>
        </div> */}


        <div className="d-flex justify-content-end mb-4">
        <button
          onClick={() => this._exportData()}
          className="btn btn-success btn-sm"
          disabled={this.state.exporting}
        >
          {this.state.exporting ? (
            <>
              <span className="spinner-border spinner-border-sm mr-2"></span>
              Exporting...
            </>
          ) : (
            "Export Customers (XLSX)"
          )}
        </button>
      </div>

<div className="card card-custom mb-5">
  <div className="card-header">
    <div className="card-title">
      <h3 className="card-label">
        Send Verification Emails
      </h3>
    </div>
  </div>

  <div className="card-body">
    <div className="d-flex align-items-center justify-content-between">
      <div>
        <div className="font-weight-bold">
          {selectedUnverifiedCount} unverified user
          {selectedUnverifiedCount === 1 ? "" : "s"} selected
        </div>

        <small className="text-muted">
          Select unverified users from the table below.
        </small>
      </div>

      <button
        type="button"
        className="btn btn-primary"
        disabled={
          !selectedUnverifiedCount ||
          this.state.verificationEmailsSending
        }
        onClick={() => this._sendVerificationEmails()}
      >
        {this.state.verificationEmailsSending ? (
          <>
            <span className="spinner-border spinner-border-sm mr-2" />
            Sending...
          </>
        ) : (
          `Send Emails (${selectedUnverifiedCount})`
        )}
      </button>
    </div>
  </div>
</div>

        <BaseTable
          {...tableProps}
          ref={this.table}
          title={this.props.title}
          loading={isLoading}
          endpoint={`${window.Api.Customers}`}
          noDataMessage={"No customers found"}
          onTotalRecordsChange={this.props.onTotalRecordsChange}
          columns={columns}
          showPagination={true}
          defaultSorted={[
            {
              id: "created_at",
              desc: true,
            },
          ]}
          getTdProps={(state, rowInfo, column, instance) => {
            return {
              style: {
                paddingLeft: 10,
                overflow: column.Header === "Actions" ? "visible" : "hidden",
              },
            };
          }}
        />
      </>
    );
  }
}

ManageCustomersTable.defaultProps = {
  title: "All Users",
  showPagination: true,
  showPaginationTop: true,
  showPaginationBottom: true,
  onTotalRecordsChange: null,
};

export default withRouter(ManageCustomersTable);
